import Grid from '@mui/material/Grid';
import Drawer from 'components/Drawer';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { groupBy } from 'selectors/generic';
import RawMaterialsTable from './RawMaterialsTable';
import StepSelector from './StepRawMaterialSelector';

// `flow.steps` used to arrive as the step rows themselves; it is now a list of
// ids, so the rows come from the steps slice, indexed once by the flow they
// belong to.
const stepsByFlow = groupBy('steps', 'flow_id');

// A flow with no steps has no key in the index, and the fallback has to keep its
// identity between renders: StepRawMaterialSelector lists `flowSteps` in an
// effect's dependencies, and that effect sets state, so a fresh [] on every
// render would loop. `flow.steps` was one array from the store and never moved.
const NO_STEPS = [];


// Every account starts with no flowcharts, and eight of the twenty-two are still there. Rendering the
// page for them meant reaching into flows.models[null] two components down, so the guard belongs
// here, once, rather than at each dereference underneath.
const NoFlows = () => (
  <Grid size={12}>
    <p>Ainda não há fluxogramas nesta conta. Crie um em Fluxogramas para poder associar-lhe etapas.</p>
  </Grid>
);

// The hooks live in FlowsSteps, so the empty check has to happen before it is called at all - returning
// early from inside it would run fewer hooks on that render than on the last one, which React refuses.
const Component = props =>
  props.flows.data.length ? <FlowsSteps {...props} /> : <NoFlows />;

const FlowsSteps = props => {
  const { flows, scenarios, stepsByFlow } = props;

  const [rawMaterial, setRawMaterial] = useState(null);
  const [flowId, setFlowId] = useState(flows.data[0].id);
  const handleCloseDrawer = () => setRawMaterial(null);

  /**
   * Compute all the production scenarios combinations [LCS + Flow, ..]
   * This will allow to give a warning in case there are step_rawMaterials
   * checked for production scenarios that haven't been created yet
   */
  const flowIds = flows.data.map(flow => flow.id);
  const lcsByFLowIdScenarios = {};
  scenarios.data
    .filter(scenario =>
      scenario.flow_id && !scenario.product_id && !scenario.substance_id
      && !scenario.raw_material_supplier_id && flowIds.includes(scenario.flow_id)
    )
    .forEach(scenario => lcsByFLowIdScenarios[scenario.flow_id] ?
      lcsByFLowIdScenarios[scenario.flow_id].push(parseInt(scenario.lcs_id)) :
      lcsByFLowIdScenarios[scenario.flow_id] = [parseInt(scenario.lcs_id)]
    );

  return (
    <Grid size={12}>
      <RawMaterialsTable
        flowId={flowId}
        setFlowId={setFlowId}
        setRawMaterial={setRawMaterial}
      />
      {
        rawMaterial &&
        <Drawer open={true} onClose={handleCloseDrawer}>
          <StepSelector
            flowId={flowId}
            flowSteps={stepsByFlow[flowId] || NO_STEPS}
            handleCloseDrawer={handleCloseDrawer}
            rawMaterialId={rawMaterial.id}
            lcsByFLowIdScenarios={lcsByFLowIdScenarios}
          />
        </Drawer>
      }
    </Grid>
  );
};

const mapStateToProps = (state, props) => ({
  flows: state.flows,
  scenarios: state.scenarios,
  stepsByFlow: stepsByFlow(state)
});

export default connect(mapStateToProps)(Component);
